<template>
  <CreateMerchantGroupUserForm />
</template>
